/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Account } from './Account';
export type LinkTelegramIdentityResponse = {
    account: Account;
    merge_result: LinkTelegramIdentityResponse.merge_result;
};
export namespace LinkTelegramIdentityResponse {
    export enum merge_result {
        LINKED = 'linked',
        MERGED_TELEGRAM_WON = 'merged_telegram_won',
    }
}

